var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
// @ts-ignore
import * as Vue from 'vue';
var allVue = Vue;
var gh = allVue.h;
var isV3 = allVue.version && allVue.version[0] === '3';
import { getTabIndex, getDefaultSlots, Icon, getIconName } from '@progress/kendo-vue-common';
import { provideLocalizationService } from '@progress/kendo-vue-intl';
import { separatorAriaMessage, messages } from '../messages/main';
/**
 * @hidden
 */
var DrawerItemVue2 = {
  name: 'KendoDrawerItem',
  // @ts-ignore
  emits: {
    click: null
  },
  props: {
    index: Number,
    text: String,
    icon: String,
    svgIcon: Object,
    separator: Boolean,
    selected: Boolean,
    disabled: Boolean,
    targetItem: [Object, Array]
  },
  inject: {
    kendoDrawer: {
      default: null
    },
    kendoLocalizationService: {
      default: null
    }
  },
  computed: {
    itemClassNames: function itemClassNames() {
      var _a = this.$props,
        disabled = _a.disabled,
        selected = _a.selected;
      return {
        'k-drawer-item': true,
        'k-selected': selected,
        'k-disabled': disabled
      };
    }
  },
  // @ts-ignore
  setup: !isV3 ? undefined : function () {
    var v3 = !!isV3;
    return {
      v3: v3
    };
  },
  // @ts-ignore
  render: function render(createElement) {
    var h = gh || createElement;
    var defaultSlot = getDefaultSlots(this);
    var _a = this.$props,
      text = _a.text,
      icon = _a.icon,
      svgIcon = _a.svgIcon,
      separator = _a.separator,
      disabled = _a.disabled,
      selected = _a.selected,
      tabIndex = _a.tabIndex;
    var _b = this.kendoDrawer,
      expanded = _b.expanded,
      mini = _b.mini,
      item = _b.item;
    var ariaLabelSeparator = provideLocalizationService(this).toLanguageString(separatorAriaMessage, messages[separatorAriaMessage]);
    return separator ? h("li", {
      "class": 'k-drawer-item k-drawer-separator',
      role: "separator",
      attrs: this.v3 ? undefined : {
        role: "separator",
        "aria-label": ariaLabelSeparator
      },
      "aria-label": ariaLabelSeparator
    }) : h("li", {
      "class": this.itemClassNames,
      role: "menuitem",
      attrs: this.v3 ? undefined : {
        role: "menuitem",
        "aria-label": text,
        "aria-current": selected,
        "aria-disabled": disabled,
        tabindex: getTabIndex(tabIndex, disabled)
      },
      "aria-label": text,
      "aria-current": selected,
      "aria-disabled": disabled,
      onClick: this.handleClick,
      on: this.v3 ? undefined : {
        "click": this.handleClick
      },
      tabindex: getTabIndex(tabIndex, disabled)
    }, [!item ? [(icon || svgIcon) && h(Icon, {
      name: getIconName(icon),
      attrs: this.v3 ? undefined : {
        name: getIconName(icon),
        icon: svgIcon
      },
      icon: svgIcon
    }), !expanded && mini ? null : h("span", {
      "class": 'k-item-text'
    }, [text])] : defaultSlot]);
  },
  methods: {
    focus: function focus(e) {
      if (this.$el) {
        this.$el.focus(e);
      }
    },
    handleClick: function handleClick() {
      if (!this.disabled) {
        var handle = {
          element: this.$el,
          focus: this.focus,
          props: __assign(__assign({}, this.$props), this.$attrs)
        };
        this.$emit('click', handle, this.$props.index);
      }
    }
  }
};
/**
 * Represents the [Kendo UI for Vue Drawer component]({% slug overview_drawer %}).
 *
 * ```jsx
 *     <Drawer
 *       :expanded="expanded"
 *       :position="position"
 *       :mode="mode"
 *       :mini="true"
 *       :width="175"
 *       :items="
 *         items.map((item, index) => ({
 *           ...item,
 *           selected: index === selectedId,
 *         }))
 *       "
 *       :item="'CustomItem'"
 *       @select="onSelect"
 *     >
 *       <template v-slot:CustomItem="{ props }">
 *         <DrawerItem v-bind="props" @click="props.onClick">
 *           <span :class="'k-icon flag ' + props.flag" />
 *           <div class="item-descr-wrap">
 *             <div>{{ props.text }}</div>
 *             <span class="item-descr">Capital of {{ props.country }}</span>
 *           </div>
 *         </DrawerItem>
 *       </template>
 *       <DrawerContent>
 *         <router-view />
 *       </DrawerContent>
 *     </Drawer>
 * ```
 *
 */
var DrawerItem = DrawerItemVue2;
export { DrawerItem, DrawerItemVue2 };